//Models
PJQ.models.screenings = {};

PJQ.models.screenings.ScreeningClient = PJQ.models.BaseModel.extend({
	idAttribute: 'masterUserId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.get('contactId') > 0 ? this.get('contactId') : PJQ.app.session.contact.id
			},
			{
				endpoint: 'screenings',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		if (model.terms) {
			if (model.terms instanceof PJQ.collections.screenings.ScreeningTerms)
				this.terms = model.terms;
			else
				this.terms = new PJQ.collections.screenings.ScreeningTerms(model.terms, {
					masterUserId: model.masterUserId
				});
		}
		else {
			this.terms = new PJQ.collections.screenings.ScreeningTerms(null, {
				masterUserId: model.masterUserId
			});
		}

		if (model.products) {
			if (model.products instanceof PJQ.collections.payment.Products)
				this.products = model.products;
			else
				this.products = new PJQ.collections.payment.Products(model.products);
		}
		else {
			this.products = new PJQ.collections.payment.Products();
		}

		if (model.categories) {
			if (model.categories instanceof PJQ.collections.screenings.ScreeningCategories)
				this.categories = model.categories;
			else
				this.categories = new PJQ.collections.screenings.ScreeningCategories(model.categories);
		}
		else {
			this.categories = new PJQ.collections.screenings.ScreeningCategories();
		}

		//Recursively set this client masterUserId to all children models
		//masterUserId is the root of all screening endpoints
		this.categories.options.masterUserId = model.masterUserId;
		_.each(this.categories.models, function (category) {
			category.set('masterUserId', model.masterUserId);

			category.items.options.masterUserId = model.masterUserId;
			_.each(category.items.models, function (item) {
				item.set('masterUserId', model.masterUserId);

				//Also set the screeningInviteItemId for all sub-items here
				//It is used for the API url
				item.attachments.options.masterUserId = model.masterUserId;
				item.attachments.options.screeningInviteItemId = item.id;
				_.each(item.attachments.models, function (attachment) {
					attachment.set({
						masterUserId: model.masterUserId,
						screeningInviteItemId: item.id
					});
				});

				_.each(item.comments.models, function (comment) {
					comment.set({
						masterUserId: model.masterUserId,
						screeningInviteItemId: item.id
					});
				});

				_.each(item.questions.models, function (question) {
					question.set({
						masterUserId: model.masterUserId,
						screeningInviteItemId: item.id
					});
				});
			});
		});

		if (model.prequal) {
			if (model.prequal instanceof PJQ.models.prequal.Prequal)
				this.prequal = model.prequal;
			else
				this.prequal = new PJQ.models.prequal.Prequal(model.prequal);
		}
		else {
			this.prequal = new PJQ.models.prequal.Prequal();
		}

		if (model.sampleDocuments) {
			if (model.sampleDocuments instanceof PJQ.collections.screenings.SampleDocuments)
				this.sampleDocuments = model.sampleDocuments;
			else
				this.sampleDocuments = new PJQ.collections.screenings.SampleDocuments(model.sampleDocuments, {
					masterUserId: model.masterUserId
				});
		}
		else {
			this.sampleDocuments = new PJQ.collections.screenings.SampleDocuments(null, {
				masterUserId: model.masterUserId
			});
		}

		if (this.preferences && model.preferences) {
			this.preferences.set(model.preferences);
		}
		else {
			this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
		}

		return model;
	},
	getItemStatusStats: function () {
		let statuses = {};
		_.each(this.categories.models, function (category) {
			_.each(category.items.models, function (item) {
				if (statuses[item.get('status').screeningStatusId] == null) {
					statuses[item.get('status').screeningStatusId] = {
						id: item.get('status').screeningStatusId,
						name: item.get('status').name,
						color: item.get('status').textColor,
						count: 1,
						sortOrder: item.get('status').sortOrder
					};
				}
				else {
					statuses[item.get('status').screeningStatusId].count++;
				}
			});
		});
		return statuses;
	},
	getAttentionItems: function () {
		let attentionItems = [];
		_.each(this.categories.models, function (category) {
			attentionItems.push(...category.getAttentionItems());
		});
		return attentionItems;
	},
	hasItems: function () {
		return _.find(this.categories.models, function (category) {
			return _.size(category.items.models) > 0;
		}) != null;
	},
	checkNeedsTerms: function () {
		return _.find(this.terms.models, function (term) {
			return term.get('isActive') && !term.get('isAccepted')
		}) != null;
	}
});

PJQ.models.screenings.ScreeningCategory = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningCategoryId',
	parse: function (model) {
		if (model.items) {
			if (model.items instanceof PJQ.collections.screenings.ScreeningItems)
				this.items = model.items;
			else
				this.items = new PJQ.collections.screenings.ScreeningItems(model.items);
		}
		else {
			this.items = new PJQ.collections.screenings.ScreeningItems();
		}

		if (model.grades) {
			if (model.grades instanceof PJQ.collections.screenings.Grades)
				this.grades = model.grades;
			else
				this.grades = new PJQ.collections.screenings.Grades(model.grades);
		}
		else {
			this.grades = new PJQ.collections.screenings.Grades();
		}
		return model;
	},
	getAttentionItems: function () {
		return _.filter(this.items.models, function (item) {
			return item.get('status').needsAttention;
		}, this);
	}
});

PJQ.models.screenings.Grade = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningGradeId'
});

PJQ.models.screenings.ScreeningItem = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningItemId'
});

PJQ.models.screenings.ScreeningInviteItem = PJQ.models.screenings.ScreeningItem.extend({
	idAttribute: 'screeningInviteItemId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.id
			}
		]);
	},
	submitProcessing: function (callback) {
		this.setStatus(PJQ.constants.screenings.statuses.IN_PROCESS, callback);
	},
	moveWaiting: function (callback) {
		this.setStatus(PJQ.constants.screenings.statuses.WAITING, callback);
	},
	setStatus: function (statusId, callback) {
		this.get('status').screeningStatusId = statusId;
		this.save(null, {
			success: _.bind(callback, this)
		});
	},
	updateExpiresOn: function (expiresOn, callback) {
		this.save({
			expiresOn: expiresOn
		}, {
			success: _.bind(callback, this)
		});
	},
	parse: function (model) {
		if (model.comments) {
			if (model.comments instanceof PJQ.collections.screenings.ScreeningComments)
				this.comments = model.comments;
			else
				this.comments = new PJQ.collections.screenings.ScreeningComments(model.comments);
		}
		else {
			this.comments = new PJQ.collections.screenings.ScreeningComments();
		}

		if (model.attachments) {
			if (model.attachments instanceof PJQ.collections.screenings.ScreeningItemAttachments)
				this.attachments = model.attachments;
			else {
				this.attachments = new PJQ.collections.screenings.ScreeningItemAttachments(model.attachments);
			}
		}
		else {
			this.attachments = new PJQ.collections.screenings.ScreeningItemAttachments(null);
		}

		if (model.questions) {
			if (model.questions instanceof PJQ.collections.screenings.ScreeningClientQuestions)
				this.questions = model.questions;
			else
				this.questions = new PJQ.collections.screenings.ScreeningClientQuestions(model.questions);
		}
		else {
			this.questions = new PJQ.collections.screenings.ScreeningClientQuestions();
		}

		return model;
	}
});

PJQ.models.screenings.ScreeningComment = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningItemCommentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.get('screeningInviteItemId')
			},
			{
				endpoint: 'comments',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		if (!model)
			return model;

		if (model.createdBy != null) {
			this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
		}

		return model;
	}
});

PJQ.models.screenings.ScreeningItemAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.get('screeningInviteItemId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

PJQ.models.screenings.ScreeningQuestion = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningItemQuestionId'
});

PJQ.models.screenings.ScreeningClientQuestion = PJQ.models.screenings.ScreeningQuestion.extend({
	idAttribute: 'screeningItemQuestionId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.get('screeningInviteItemId')
			},
			{
				endpoint: 'questions',
				value: this.id
			},
			{
				endpoint: 'response'
			}
		]);
	}
});

PJQ.models.screenings.SampleDocument = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningSampleDocumentId',
	download: function () {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'sampledocuments',
				value: this.id
			}
		]));
	}
});

PJQ.models.screenings.ScreeningTerm = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningTermsId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'terms',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.screenings = {};

PJQ.collections.screenings.ScreeningClients = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningClient,
	endpoint: function () {
		if (this.options.masterUserId > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.options.contact.id
				},
				{
					endpoint: 'screenings'
				}
			], [
				{
					parameter: 'masterUserId',
					value: this.options.masterUserId
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.options.contact.id
				},
				{
					endpoint: 'screenings'
				}
			]);
		}
	},
	hasItems: function () {
		let hasItems = false;
		_.each(this.models, function (client) {
			if (client.hasItems()) {
				hasItems = true;
			}
		});
		return hasItems;
	}
});

PJQ.collections.screenings.ScreeningCategories = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningCategory,
	getItems: function () {
		let items = [];
		_.each(this.models, function (category) {
			_.each(category.items.models, function (item) {
				items.push(item);
			});
		});
		return items;
	}
});

PJQ.collections.screenings.Grades = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.Grade
});

PJQ.collections.screenings.ScreeningItems = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningInviteItem
});

PJQ.collections.screenings.ScreeningComments = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningComment
});

PJQ.collections.screenings.ScreeningItemAttachments = PJQ.collections.files.Files.extend({
	model: PJQ.models.screenings.ScreeningItemAttachment,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.options.masterUserId
			},
			{
				endpoint: 'items',
				value: this.options.screeningInviteItemId
			},
			{
				endpoint: 'attachments'
			}
		]);
	}
});

PJQ.collections.screenings.ScreeningQuestions = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningQuestion
});

PJQ.collections.screenings.ScreeningClientQuestions = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningClientQuestion
});

PJQ.collections.screenings.SampleDocuments = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.SampleDocument,
	download: function () {
		PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.options.masterUserId
			},
			{
				endpoint: 'sampledocuments'
			}
		]));
	}
});

PJQ.collections.screenings.ScreeningTerms = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningTerm,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.constants.publicUserId
			},
			{
				endpoint: 'terms'
			}
		]);
	}
});